import { BACKEND_URL } from "lib/utils/baseUrl";
import { authFetch } from "lib/api/authFetch";

async function parseApprovalResponse(response) {
  const data = await response.json().catch(() => ({}));

  return {
    success: response.ok && data?.success === true,
    message: data?.message ?? "",
    code: data?.code ?? "",
    data: data?.data ?? null,
  };
}

export async function getApprovalRequests({
  requestType = "signup_approval",
  status = "pending",
} = {}) {
  try {
    const params = new URLSearchParams({
      request_type: requestType,
      status,
    });
    const response = await authFetch(
      `${BACKEND_URL}/user/approval-requests?${params.toString()}`,
      {
        method: "GET",
      },
    );

    return parseApprovalResponse(response);
  } catch (error) {
    console.error("[getApprovalRequests] failed:", error);
    return {
      success: false,
      message: "승인 요청 목록 조회 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function markApprovalRequestRead(id) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/user/approval-requests/${id}/read`,
      {
        method: "PATCH",
      },
    );

    return parseApprovalResponse(response);
  } catch (error) {
    console.error("[markApprovalRequestRead] failed:", error);
    return {
      success: false,
      message: "승인 요청 읽음 처리 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function approveApprovalRequest(id) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/user/approval-requests/${id}/approve`,
      {
        method: "POST",
      },
    );

    return parseApprovalResponse(response);
  } catch (error) {
    console.error("[approveApprovalRequest] failed:", error);
    return {
      success: false,
      message: "회원가입 승인 처리 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}

export async function rejectApprovalRequest(id) {
  try {
    const response = await authFetch(
      `${BACKEND_URL}/user/approval-requests/${id}/reject`,
      {
        method: "POST",
      },
    );

    return parseApprovalResponse(response);
  } catch (error) {
    console.error("[rejectApprovalRequest] failed:", error);
    return {
      success: false,
      message: "회원가입 거절 처리 중 오류가 발생했습니다.",
      code: "NETWORK_ERROR",
      data: null,
    };
  }
}
